module.exports = __webpack_public_path__ + "img/qdqmedia.88d0c9f5.png";